module.exports = __webpack_public_path__ + "img/icon-workorder.46e46a0f.png";